/* DISCOVERS — Premium Interactive JS v3 */
(function () {
  'use strict';

  /* ── CUSTOM CURSOR ── */
  function initCursor() {
    const el = document.createElement('div');
    el.id = 'd-cursor';
    el.style.cssText = `
      width:10px;height:10px;background:#F2F2F8;border-radius:50%;
      position:fixed;top:0;left:0;pointer-events:none;z-index:99999;
      transform:translate(-50%,-50%);mix-blend-mode:difference;
      transition:width .3s ease,height .3s ease,background .3s;
    `;
    document.body.appendChild(el);
    let tx = -100, ty = -100, cx = -100, cy = -100;
    window.addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; });
    (function loop() {
      cx += (tx - cx) * 0.14;
      cy += (ty - cy) * 0.14;
      el.style.left = cx + 'px';
      el.style.top  = cy + 'px';
      requestAnimationFrame(loop);
    })();
    document.querySelectorAll('a,button,.card-wrapper,.card,input,select').forEach(t => {
      t.addEventListener('mouseenter', () => { el.style.width='38px'; el.style.height='38px'; });
      t.addEventListener('mouseleave', () => { el.style.width='10px'; el.style.height='10px'; });
    });
    document.body.style.cursor = 'none';
    document.querySelectorAll('a,button,input,select,[class*="card"]').forEach(t => t.style.cursor = 'none');
  }

  /* ── LOADER ── */
  function initLoader() {
    const ld = document.createElement('div');
    ld.innerHTML = `
      <div style="font-family:'Outfit',sans-serif;font-size:26px;font-weight:800;letter-spacing:-.04em;color:#F2F2F8;margin-bottom:20px">Discovers</div>
      <div style="width:100px;height:1px;background:rgba(255,255,255,0.08);border-radius:1px;overflow:hidden;position:relative">
        <div id="d-bar" style="position:absolute;left:-100%;top:0;width:100%;height:100%;background:linear-gradient(90deg,#9D8DF1,#3ECFB2);transition:left .9s cubic-bezier(.22,1,.36,1)"></div>
      </div>
    `;
    Object.assign(ld.style, {
      position:'fixed',inset:'0',background:'#060608',zIndex:'99997',
      display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',
      transition:'opacity .5s ease,visibility .5s'
    });
    document.body.prepend(ld);
    requestAnimationFrame(() => {
      document.getElementById('d-bar').style.left = '0%';
    });
    const hide = () => { ld.style.opacity='0'; ld.style.visibility='hidden'; setTimeout(()=>ld.remove(),600); };
    if (document.readyState === 'complete') setTimeout(hide, 1000);
    else window.addEventListener('load', () => setTimeout(hide, 900));
  }

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    const sel = [
      '.card-wrapper','.card','[class*="featured-collection"] > *',
      '[class*="rich-text"] > *','[class*="image-with-text"] > *',
      '[class*="icon-with-text"]','[class*="multicolumn-card"]',
      '.banner__content','h2','.title-wrapper',
      '[class*="footer"] > *'
    ].join(',');

    document.querySelectorAll(sel).forEach((el, i) => {
      el.classList.add('d-reveal', `d-d${(i % 4) + 1}`);
    });

    new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -30px 0px' })
    .observe.bind(
      new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
      }, { threshold: 0.07 })
    );

    // simpler approach
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
    }, { threshold: 0.07, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.d-reveal').forEach(el => obs.observe(el));
  }

  /* ── 3D CARD TILT ── */
  function initTilt() {
    document.querySelectorAll('.card-wrapper, .card, [class*="multicolumn-card"]').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width  - 0.5;
        const y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transition = 'transform .05s, border-color .35s, box-shadow .35s';
        card.style.transform = `perspective(700px) rotateX(${-y*7}deg) rotateY(${x*7}deg) scale3d(1.02,1.02,1.02)`;
      });
      card.addEventListener('mouseleave', () => {
        card.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1), border-color .35s, box-shadow .35s';
        card.style.transform = 'perspective(700px) rotateX(0) rotateY(0) scale3d(1,1,1)';
      });
    });
  }

  /* ── MAGNETIC BUTTONS ── */
  function initMagnetic() {
    document.querySelectorAll('.button,[class*="button--primary"]').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.28;
        const y = (e.clientY - r.top - r.height / 2) * 0.28;
        btn.style.transform = `translate(${x}px,${y}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1), border-color .3s, box-shadow .3s, color .3s';
        btn.style.transform = '';
      });
      btn.addEventListener('mouseenter', () => {
        btn.style.transition = 'transform .05s, border-color .3s, box-shadow .3s, color .3s';
      });
    });
  }

  /* ── PARALLAX HERO ── */
  function initParallax() {
    const img = document.querySelector('.banner__media img, [class*="slideshow__media"] img');
    if (!img) return;
    window.addEventListener('scroll', () => {
      img.style.transform = `scale(1.06) translateY(${window.scrollY * 0.2}px)`;
    }, { passive: true });
  }

  /* ── HERO MOUSE GLOW ── */
  function initHeroGlow() {
    const hero = document.querySelector('.banner, .slideshow, [class*="slideshow__slide"]');
    if (!hero) return;
    const glow = document.createElement('div');
    Object.assign(glow.style, {
      position:'absolute',width:'500px',height:'500px',borderRadius:'50%',
      background:'radial-gradient(circle,rgba(157,141,241,0.12) 0%,transparent 65%)',
      pointerEvents:'none',zIndex:'1',transition:'left .4s ease,top .4s ease',
      transform:'translate(-50%,-50%)'
    });
    hero.style.position = 'relative';
    hero.appendChild(glow);
    hero.addEventListener('mousemove', e => {
      const r = hero.getBoundingClientRect();
      glow.style.left = (e.clientX - r.left) + 'px';
      glow.style.top  = (e.clientY - r.top)  + 'px';
    });
  }

  /* ── SMOOTH SCROLL ── */
  function initScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const t = document.querySelector(a.getAttribute('href'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  /* ── STAGGER PRODUCT CARDS ── */
  function staggerCards() {
    document.querySelectorAll('.card-wrapper, .card').forEach((card, i) => {
      card.style.animationDelay = `${i * 0.06}s`;
    });
  }

  /* ── INIT ── */
  function init() {
    initLoader();
    initCursor();
    initReveal();
    initTilt();
    initMagnetic();
    initParallax();
    initHeroGlow();
    initScroll();
    staggerCards();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
